import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  /* margin-top: 20px; */
`;
export const PhotoWrap = styled.div`
  position: relative;

  > span {
    position: absolute;
    color: red;
    bottom: -16px;
    font-size: 12px;
  }
`;
